import { NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { RouterLinkDirective } from '@hyundai/ng-common-lib';
import { CheckoutWrapperComponent as CheckoutWrapperComponentLib } from '@pixelgenau/ngx-checkouts';

@Component({
    selector: 'ui-m000-c030-checkout-wrapper[identifier]',
    standalone: true,
    imports: [NgClass, RouterLinkDirective],
    templateUrl: './m000-c030-checkout-wrapper.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M000C030CheckoutWrapperComponent extends CheckoutWrapperComponentLib {
    onlyOneStep = input(false, { transform: booleanAttribute });

    minHeightClass = input('min-h-[85vh]');
    customWrapperClasses = input<string>();
    customThanksPage = input(false, { transform: booleanAttribute });
    backButton = input<string>();

    hasContentPadding = computed(() => {
        const isCompleted = this.completed();
        if (isCompleted && this.customThanksPage()) {
            return false;
        }
        return isCompleted || !this.currentStep()?.showSidebar;
    });
}
